import type { ComponentProps } from "react";
import { cn } from "@/lib/cn";

/** Table anatomy from the design system: canvas header, micro-cap labels, 13px rows. */
export function Table({ className, ...rest }: ComponentProps<"table">) {
  return (
    <div className="overflow-x-auto rounded-[14px] border border-line bg-white">
      <table className={cn("w-full border-collapse text-left", className)} {...rest} />
    </div>
  );
}

export function THead({ className, ...rest }: ComponentProps<"thead">) {
  return <thead className={cn("bg-canvas", className)} {...rest} />;
}

export function TH({ className, ...rest }: ComponentProps<"th">) {
  return <th className={cn("px-[18px] py-[11px] text-[11px] font-bold uppercase tracking-[0.06em] text-muted whitespace-nowrap", className)} {...rest} />;
}

export function TR({ className, interactive, ...rest }: ComponentProps<"tr"> & { interactive?: boolean }) {
  return <tr className={cn("border-t border-line", interactive && "cursor-pointer hover:bg-canvas/60", className)} {...rest} />;
}

export function TD({ className, ...rest }: ComponentProps<"td">) {
  return <td className={cn("px-[18px] py-[13px] align-middle text-[13px] text-ink", className)} {...rest} />;
}

/** Document references (FAC-2026-0148) are monospaced. */
export function Ref({ className, ...rest }: ComponentProps<"span">) {
  return <span className={cn("font-mono text-xs text-muted", className)} {...rest} />;
}
